export default {
    personal: {
        type: "personal",
        color: "#1871f8"
    },
    system: {
        type: "system",
        color: "#7232dd"
    }
}